// Vertaalt de vaste teksten in index.html. Een element krijgt een of meer van deze attributen:
//   data-i18n="sleutel"        zet de tekst
//   data-i18n-html="sleutel"   zet tekst met <b> (alleen eigen teksten uit nl.ts/en.ts, nooit invoer van spelers)
//   data-i18n-aria="sleutel"   zet aria-label
//   data-i18n-title="sleutel"  zet title
// De Nederlandse tekst staat ook gewoon in index.html, als terugval voordat het script geladen is.
import { getLanguage, t, type MessageKey } from './index';

export function applyStatic(root: ParentNode = document): void {
  for (const el of root.querySelectorAll<HTMLElement>('[data-i18n]')) el.textContent = t(el.dataset.i18n as MessageKey);
  for (const el of root.querySelectorAll<HTMLElement>('[data-i18n-html]')) el.innerHTML = t(el.dataset.i18nHtml as MessageKey);
  for (const el of root.querySelectorAll<HTMLElement>('[data-i18n-aria]')) el.setAttribute('aria-label', t(el.dataset.i18nAria as MessageKey));
  for (const el of root.querySelectorAll<HTMLElement>('[data-i18n-title]')) el.setAttribute('title', t(el.dataset.i18nTitle as MessageKey));
}

/** Taal van de pagina zelf: html lang, titel en omschrijving (voor zoekmachines, deelknoppen en schermlezers). */
export function applyDocumentLanguage(): void {
  document.documentElement.lang = getLanguage();
  document.title = t('meta.title');
  const set = (selector: string, value: string) => document.querySelector(selector)?.setAttribute('content', value);
  set('meta[name="description"]', t('meta.description'));
  set('meta[property="og:title"]', t('meta.title'));
  set('meta[property="og:description"]', t('meta.ogDescription'));
}
